(function () {
  function apply(input, qty) {
    if (!input || !qty) return;
    input.value = qty;
    input.setAttribute('value', qty);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('[data-perfect-offer]').forEach(function (box) {
      if (box.dataset.poBound === 'true') return;
      box.dataset.poBound = 'true';

      var targetId = box.getAttribute('data-quantity-target');
      var getInput = function () { return document.getElementById(targetId); };

      box.querySelectorAll('input[type="radio"][data-qty]').forEach(function (radio) {
        radio.addEventListener('change', function () {
          if (radio.checked) apply(getInput(), radio.getAttribute('data-qty'));
        });
      });

      var checked = box.querySelector('input[type="radio"][data-qty]:checked');
      if (checked) apply(getInput(), checked.getAttribute('data-qty'));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  // Re-init after theme-editor re-renders a section
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
